import React, { useState } from "react";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import { Accordion, AccordionDetails, AccordionSummary, Card, FormLabel, Grid, Typography } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useController, useFormContext } from "react-hook-form";
import Products from "./Products";
import Categories from "./Categories";
import { ExpandMore } from "@mui/icons-material";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import { talenV5 } from "../../../../variables/app";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import AsyncProductAutocompleteTC from "../../../../components/Forms/AsyncAutocomplete/Product/AsyncProductAutocompleteTC";
import { DefaultOptionForAsyncProductAutocomplete } from "../../../../components/Forms/AsyncAutocomplete/Product/DefaultOptionForAsyncProductAutocomplete";
import { FormattedNumber } from "react-intl";

export default function General() {
  const { vestigingId, vestiging } = useFormContext();

  const [translationsInit, setTranslationsInit] = useState({});

  const {
    field: { value: translationsValue, onChange: translationsOnChange },
  } = useController({ name: "translations" });

  if (Object.keys(translationsInit).length === 0 && translationsValue != null) {
    setTranslationsInit(translationsValue);
  }
  return (
    <>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <FormTextTC
                name={"name"}
                rules={{
                  required: { message: "Is required!", value: true },
                }}
                tDefault={"Name"}
                tKey={"packaging.name"}
              />

              <FormAsyncTC
                async={{
                  url: `core/packagingTypes/search?fields=id as value, name as label&per_page=50&vestiging_id=${vestigingId}`,
                  searchField: "name",
                }}
                name={"packaging_type_id"}
                nullable
                rules={{ required: { value: true, message: "Is required" } }}
                tDefault={"Packaging type"}
                tKey={"packaging.packaging_type"}
              />

              <AsyncProductAutocompleteTC
                async_url={`core/producten/search?fields=id as value,naam as label,id,naam,snaam,blocked,is_actief,prijs&per_page=50&vestiging_id=${vestigingId}`}
                autocompleteProps={{
                  renderOption: (props, option) => {
                    return (
                      <li
                        {...props}
                        style={{
                          display: "grid",
                          gap: "8px",
                          gridTemplateColumns: "minmax(80px, min-content) minmax(40%, auto) minmax(min-content, auto)",
                        }}
                      >
                        <Typography style={{ color: "#999" }}>#{option.value}</Typography>
                        <span>
                          <DefaultOptionForAsyncProductAutocomplete option={option} />
                        </span>
                        <FormattedNumber
                          currency={vestiging?.valuta ?? "EUR"}
                          style={"currency"}
                          value={option.price}
                        />
                      </li>
                    );
                  },
                }}
                name={"product_id"}
                tDefault={"Packaging product"}
                tKey={"packaging.product"}
              />
              {/*<FormAsyncTC*/}
              {/*  async={{*/}
              {/*    url:,*/}
              {/*    searchField: "naam",*/}
              {/*  }}*/}
              {/*  nullable*/}
              {/*  tKey={"packaging.product"}*/}
              {/*  tDefault={"Packaging product"}*/}
              {/*/>*/}
              <FormSwitchTC
                name={"add_price_per_order"}
                tDefault={"Costs per order"}
                tKey={"packaging.add_price_per_order"}
              />
              <FormSwitchTC
                name={"add_price_per_item"}
                tDefault={"Costs per item"}
                tKey={"packaging.add_price_per_item"}
              />
            </Grid>
          </Grid>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <TranslationWrapper tDefault={"Translations"} tKey={"Translations"} />
            </AccordionSummary>
            <AccordionDetails>
              {Object.keys(talenV5).map((objKey) => {
                const taal = talenV5[objKey];

                return (
                  <FormTextTC
                    key={objKey}
                    label={
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Naam in"}
                          tKey={"packagingType.form.vertalingennaam.label.naam"}
                        />{" "}
                        <TranslationWrapper tDefault={taal.label} tKey={"global." + taal.transKey} />
                      </FormLabel>
                    }
                    name={"translations." + objKey + ".name"}
                  />
                );
              })}
            </AccordionDetails>
          </Accordion>
        </CardBody>
      </Card>
      <Categories />
      <Products />
    </>
  );
}
